import { writable } from 'svelte/store';

import surveys from './surveys';

let store = writable(null);

export default {
    subscribe: store.subscribe,
    set: store.set,

    _form(form) {
        let frm = new FormData();

        for (let key in form) {
            if (!form.hasOwnProperty(key)) continue;

            frm.set(key, form[key]);
        }

        return frm;
    },

    signIn(email, pass) {
        let form = { email, pass };

        return fetch('/api/sign-in', {
            credentials: 'same-origin',
            method: 'POST',
            body: this._form(form)
        })
        .then(res => {
            if (!res.ok) throw new Error('Not logged in');

            return res.json();
        })
        .then(res => {
            store.set(res);

            surveys.load();

            window.Sentry && Sentry.setUser({ id: res.cln_id, username: res.cln_name, email: res.cln_email });

            return res;
        }).catch(e => {
            return false;
        });
    },

    signUp(form) {
        return fetch('/api/sign-up', {
            credentials: 'same-origin',
            method: 'POST',
            body: this._form(form)
        })
        .then(res => {
            if (!res.ok) throw new Error('Sign up failed');

            return res.json();
        })
        .then(res => {
            // Auto-sign-in
            if (res && res.status) return this.load();

            return false;
        }).catch(e => {
            return false;
        });
    },

    setupPassword(clnId, code, pass) {
        let form = { clnId };

        if (code) {
            form.code = code;
            form.pass = pass;
        }

        return fetch('/api/setup-password', {
            credentials: 'same-origin',
            method: 'POST',
            body: this._form(form)
        })
        .then(res => {
            if (!res.ok) throw new Error('Oh no');

            return res.json();
        })
        .then(res => {
            return res && res.status;
        }).catch(e => {
            return false;
        });
    },

    signOut() {
        return fetch('/api/sign-out', {
            credentials: 'same-origin'
        })
        .then(res => {
            if (!res.ok) throw new Error('Not logged in');

            store.set(null);

            surveys.clear();

            window.Sentry && Sentry.setUser(null);
        })
        .catch(e => {
            console.log('Failed to sign-out');
        });
    },

    load() {
        return fetch('/api/me', {
            credentials: 'same-origin'
        })
        .then(res => {
            if (!res.ok) throw new Error('Not logged in');

            return res.json();
        })
        .then(res => {
            store.set(res);

            surveys.load();

            window.Sentry && Sentry.setUser({ id: res.cln_id, username: res.cln_name, email: res.cln_email });

            return res;
        })
        .catch(e => {
            store.set(null)

            return false;
        });
    },

    getByEmail(email) {
        let form = new FormData();
        form.set('email', email);

        return fetch('/api/get-user', {
            credentials: 'same-origin',
            method: 'POST',
            body: form
        }).then(res => {
            if (!res.ok) throw new Error('User not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    },

    password(clnId, code) {
        return fetch('/api/password', {
            credentials: 'same-origin',
            method: 'POST',
            body: this._form({ clnId, code })
        }).then(res => {
            if (!res.ok) throw new Error('User not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    },

    verify(clnId, code) {
        return fetch('/api/verify', {
            credentials: 'same-origin',
            method: 'POST',
            body: this._form({ clnId, code })
        }).then(res => {
            if (!res.ok) throw new Error('User not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    },

    getReservation(resId, code) {
        return fetch(`/api/reservation/${resId}/${code}`, {
            credentials: 'same-origin',
            method: 'GET'
        }).then(res => {
            if (!res.ok) throw new Error('Reservation not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    },

    cancelReservation(resId, code) {
        return fetch(`/api/cancel-reservation/${resId}/${code}`, {
            credentials: 'same-origin',
            method: 'GET'
        }).then(res => {
            if (!res.ok) throw new Error('Reservation not found');

            return res.json();
        }).catch(e => {
            return false;
        });
    },

    addSub(name, phone) {
        return fetch('/api/add-sub', {
            credentials: 'same-origin',
            method: 'POST',
            body: this._form({ name, phone })
        }).then(res => {
            if (!res.ok) throw new Error('User not logged in');

            return res.json();
        }).catch(e => {
            return false;
        });
    },

    updateDetails(name, phone) {
        return fetch('/api/update-details', {
            credentials: 'same-origin',
            method: 'POST',
            body: this._form({ name, phone })
        }).then(res => {
            if (!res.ok) throw new Error('User not logged in');

            return res.json();
        }).catch(e => {
            return false;
        });
    }
};